export default {
  100: 'pay_pending',
  101: 'paid',
  102: 'inprogress',
  103: 'completed',
  104: 'expired',
  105: 'resultReady',
  106: 'PaidAndLocked',
  107: 'StartedAndlocked',
}
